import React from "react";
import {endOfMonth, formatISO, parseISO, startOfMonth} from "date-fns";

import useCachedPrices from "../useCachedPrices";
import {extractRateId, isBaseResource, isPeopleResource, extractPeople} from "../calendarResourceUtils";
import {usePlanner} from "../../../../components/Planner";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {Checkbox} from "@mui/material";


const PeriodSummary = ({apartmentId}) => {
    const {selectedRange} = usePlanner();
    const  getCachedPrices = useCachedPrices();

    // extract rate id from selected resource
    const rateId = selectedRange.resource && extractRateId(selectedRange.resource);

    // extract people from selected resource
    const selectedPeople = selectedRange.resource && (
        isPeopleResource(selectedRange.resource) || isBaseResource(selectedRange.resource)
    )
    const people = selectedPeople && extractPeople(selectedRange.resource);

    // extract nights from selected range
    const dateFrom = selectedRange.from && parseISO(selectedRange.from);
    const dateTo = selectedRange.to && parseISO(selectedRange.to);
    const nights = dateFrom && dateTo ? Math.round((dateTo - dateFrom) / (1000 * 60 * 60 * 24)) + 1 : 0;

    const startOfMonthISO = dateFrom && formatISO(startOfMonth(dateFrom), {representation: 'date'});
    const endOfMonthISO = dateTo && formatISO(endOfMonth(dateTo), {representation: 'date'});

    const startMonthDate = parseISO(startOfMonthISO);
    const endMonthDate = parseISO(endOfMonthISO);
    const cachedPrice = (!selectedRange.from || !selectedRange.to) ? null : getCachedPrices(apartmentId, rateId, startMonthDate, endMonthDate);

    let priceCent = null;
    if (people && cachedPrice) {
        const indexFrom = cachedPrice.timestamps.findIndex(t => t === selectedRange.from);
        const indexTo = cachedPrice.timestamps.findIndex(t => t === selectedRange.to);
        // show the price for the minPeople if people is less than minPeople for at least one day
        const minPeople = Math.max(people, ...cachedPrice.minPeople.slice(indexFrom, indexTo + 1));
        const pricesCent = cachedPrice.pricesCent[minPeople];
        const selectedPricesCent = pricesCent?.slice(indexFrom, indexTo + 1);
        if(selectedPricesCent) {
            priceCent = selectedPricesCent.reduce((a, b) => a + b, 0);
        }
    }

    const noSelection = !dateFrom || !dateTo ;
    const color = noSelection ? "text.disabled" : "text.primary";

    return <Stack direction="row" alignItems="center" spacing={1}>
        <Stack>
            <Typography variant="caption" color={color} textAlign="center">
                { noSelection ?  "Nessun periodo selezionato" : "Info selezione"}
            </Typography>
            <Stack direction="row" spacing={1}>
                <Checkbox checked={!noSelection} color="default" size="small" sx={{p: 0, visibility: !!noSelection ? "hidden" : "visible"}}/>
                <Typography lineHeight='1.25rem' fontWeight={600} color={color}>
                    {nights} Notti - Prezzo totale {priceCent / 100 || "--.--"} €
                </Typography>
            </Stack>
        </Stack>
    </Stack>

}

export default PeriodSummary;